import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SkeletonButtonsComponent } from './skeleton/skeleton-buttons/skeleton-buttons.component';
import { SkeletonLoaderComponent } from './skeleton/skeleton-loader/skeleton-loader.component';
import { SkeletonProfileComponent } from './skeleton/skeleton-profile/skeleton-profile.component';
import { SkeletonTextComponent } from './skeleton/skeleton-text/skeleton-text.component';
import { SkeletonContainerComponent } from './skeleton/skeleton-container/skeleton-container.component';
import { SkeletonRouteComponent } from './skeleton/skeleton-route/skeleton-route.component';
import { SkeletonTableComponent } from './skeleton/skeleton-table/skeleton-table.component';
import { LanguageModule } from '../language/language.module';
import { CardEmptyModule } from '../card-empty/card-empty.module';
import { SkeletonListContainerComponent } from './skeleton/skeleton-list-container/skeleton-list-container.component';

@NgModule({
  declarations: [
    SkeletonLoaderComponent,
    SkeletonProfileComponent,
    SkeletonButtonsComponent,
    SkeletonTextComponent,
    SkeletonContainerComponent,
    SkeletonRouteComponent,
    SkeletonTableComponent,
    SkeletonListContainerComponent,
  ],
  imports: [CommonModule, LanguageModule, CardEmptyModule],
  exports: [
    SkeletonLoaderComponent,
    SkeletonProfileComponent,
    SkeletonButtonsComponent,
    SkeletonTextComponent,
    SkeletonContainerComponent,
    SkeletonRouteComponent,
    SkeletonTableComponent,
    SkeletonListContainerComponent
  ],
  entryComponents: [SkeletonLoaderComponent],
})
export class SubscriberModule {}
